import React from "react";
import theme from "./theme";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
} from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  CssBaseline,
  ThemeProvider,
  Box,
  useMediaQuery,
} from "@mui/material";
//---------------- Styles---------------- 
// import './stylesheet.css'; // Removed - using Tailwind CDN in index.html
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.css';
import './loding.css';

//---------------- Auth---------------- 
import { AuthProvider, useAuth } from "./AuthContext";

//---------------- Navbar + Logout---------------- 
import HorizontalNavbar from "./HorizontalNavbar";
import MobileBottomNav from "./MobileBottomNav";
import Logout from "./Logout";

//---------------- PWA Components---------------- 
// PWA Status component removed

//---------------- Service Worker Registration---------------- 
// Service worker registration removed

//---------------- Styles---------------- 
// import './stylesheet.css'; // Removed - using Tailwind CDN in index.html
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.css';
import './loding.css';
import LodingComponent from "./loding";
// import Loginlogo from "./Loginlogo.png";

//-----------SessionTimeOut---------
import SessionTimeout from "./SessionTimeout";

//-----------Company----------------
import CompanyEdit from "./components/pages/Company/Edit";

//-----------Home-------------------
import Home from "./components/pages/Home";
//-----------Role-------------------
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";

//-----------User-------------------
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

//-----------Client-------------------
import ClientIndex from "./components/pages/Client/Index";

//-----------Vendor-------------------
import VendorIndex from "./components/pages/Vendor/Index";

//-----------AccountHead-------------------
import AccountHeadIndex from "./components/pages/AccountHead/Index";

//-----------Bank-------------------
import BankIndex from "./components/pages/Bank/Index";

//-----------Category-------------------
import CategoryIndex from "./components/pages/Category/Index";

//-----------Item-------------------
import ItemIndex from "./components/pages/Item/Index";

//-----------Event Item Enquiry-------------------
import EventItemEnquiryIndex from "./components/pages/EventItemEnquiry/Index";

//-----------Product Enquiry-------------------
import EnquiryIndex from "./components/pages/Enquiry/Index";

//-----------Estimate-------------------
import EstimateIndex from "./components/pages/Estimate/EstimateIndex";

//-----------DeliveryOut-------------------
import DeliveryIndex from "./components/pages/Delivery/DeliveryIndex";

//-----------DeliveryIn-------------------
import DeliveryInIndex from "./components/pages/Delivery/DeliveryInIndex";

//-----------RentInvoice-------------------
import RentInvoiceIndex from "./components/pages/RentInvoice/RentInvoiceIndex";

//------------Reports-----------------
import MonthlyEstimateReport from "./components/pages/Report/MonthlyEstimate";
import ItemForecastReport from "./components/pages/Report/ItemForecastReport";

import DeliverySummaryReport from "./components/pages/Report/DeliverySummaryReport";
import LedgerReport from "./components/pages/Report/LedgerReport";
import CashBook from "./components/pages/Report/CashBook";
import DeliveryStockReport from "./components/pages/Report/DeliveryStockReport";
import CustomerDueListReport from "./components/pages/Report/CustomerDueListReport";
import VendorDueListReport from "./components/pages/Report/VendorDueListReport";

import PurchasePartyandItemWiseReport from "./components/pages/Report/PurchasePartyandItemWiseReport";
import SalePartyandItemWiseReport from "./components/pages/Report/SalePartyandItemWiseReport";
import RentInvoicePartyandItemWiseReport from "./components/pages/Report/RentInvoicePartyandItemWiseReport";
//-----------Item-------------------
// ItemDashboard removed - file not found

//-----------Master (Client & Vendor)-------------------
// MasterDashboard removed - file not found

//-----------Bank-------------------
// BankDashboard removed - file not found

//-----------Staff-------------------
// StaffDashboard removed - file not found

//-----------AccountHead-------------------
// AccountHeadDashboard removed - file not found

//-----------PurchaseOrder-------------------
// PurchaseOrderIndex removed - file not found

//-----------Purchase-------------------
import PurchaseIndex from "./components/pages/Purchase/PurchaseIndex";

//-----------PurchaseReturn-------------------
// PurchaseReturnAgainstIndex removed - file not found

//-----------Quotation-------------------
// QuotationIndex removed - file not found

//-----------SalesOrder-------------------
// SalesOrderIndex removed - file not found

//-----------Sale-------------------
import SaleIndex from "./components/pages/Sale/SaleIndex";

//-----------Stock-------------------
// StockTransferInIndex removed - file not found
// StockTransferOutIndex removed - file not found

//-----------PaymentReceipts-------------------
import PaymentReceiptsIndex from "./components/pages/PaymentReceipts/PaymentReceiptsIndex";

//-----------JournalEntry-------------------
import JournalEntryIndex from "./components/pages/JournalEntry/JournalEntryIndex";

//-----------StockReport-------------------
import StockReportIndex from "./components/pages/StockReport/Index";


// ---------------- Theme ---------------- //


//const Sidebar = ({ open, roleName }) => {
// ---------------- Layout ---------------- //
const Layout = () => {
  const { companyName, roleName, username, isAuthenticated } = useAuth();
  const isMobile = useMediaQuery('(max-width:1199px)');

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {/* Session Timeout Component - only render when authenticated */}
        {isAuthenticated && <SessionTimeout />}

        {/* PWA Status Component - Removed */}

        {/* Header with integrated menu */}
        <AppBar className="app-header" position="fixed" sx={{ zIndex: (t) => t.zIndex.drawer + 1, backgroundColor: '#102c36', boxShadow: '0 4px 24px rgba(16,44,54,.12)' }}>
          <Toolbar sx={{ minHeight: '56px !important', px: { xs: 2, md: 3 }, gap: 1 }}>
            {/* Company Name */}
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, mr: 1, minWidth: 0, maxWidth: { xs: "70%", lg: 220 }, flexShrink: 1 }}
            >
              <Link to="/Home" style={{ textDecoration: "none", color: "inherit" }}>
                <span className="app-brand">{companyName || "Event Rent Suite"}</span>
              </Link>
            </Typography>

            {/* Navigation Menu - Desktop only */}
            {!isMobile && username !== "Counter" && <HorizontalNavbar />}

            {/* Spacer */}
            <Box sx={{ flexGrow: 1 }} />

            {/* Logout icon only */}
            <Logout />
          </Toolbar>
        </AppBar>

        {/* Content */}
        <Box component="main" className="app-main"
          sx={{
            pt: 'calc(56px + env(safe-area-inset-top))',
            pb: isMobile && username !== 'Counter' ? 'calc(80px + env(safe-area-inset-bottom))' : 0, // Add padding for bottom nav on mobile
            minHeight: '100vh',
            backgroundColor: '#f3f6f7',
          }}
        >
          <Box sx={{ p: 0 }}>
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/Home" exact component={Home} />

              {/* Role */}
              <Route path="/RoleIndex" component={RoleIndex} />
              <Route path="/RoleDetail/:id" component={RoleDetail} />

              {/* User */}
              <Route path="/UserIndex" component={UserIndex} />
              <Route path="/UserCreate" component={UserCreate} />
              <Route path="/UserEdit/:id" component={UserEdit} />
              <Route path="/UserDetail/:id" component={UserDetail} />
              <Route path="/PasswordChange" component={PasswordChange} />

              {/* Client */}
              <Route path="/clientIndex" component={ClientIndex} />

              {/* Vendor */}
              <Route path="/vendorIndex" component={VendorIndex} />

              {/* AccountHead */}
              <Route path="/accountHeadIndex" component={AccountHeadIndex} />

              {/* Bank */}
              <Route path="/bankIndex" component={BankIndex} />

              {/* Category */}
              <Route path="/categoryIndex" component={CategoryIndex} />

              {/* Item */}
              <Route path="/itemIndex" component={ItemIndex} />

              {/* Event Item Enquiry */}
              <Route path="/EventItemEnquiryIndex" component={EventItemEnquiryIndex} />

              {/* Product Enquiry */}
              <Route path="/EnquiryIndex" component={EnquiryIndex} />

              {/* Estimate */}
              <Route path="/EstimateIndex" component={EstimateIndex} />

              {/* DeliveryOut */}
              <Route path="/DeliveryIndex" component={DeliveryIndex} />

              {/* DeliveryIn */}
              <Route path="/DeliveryInIndex" component={DeliveryInIndex} />

              {/* RentInvoiceIndex */}
              <Route path="/RentInvoiceIndex" component={RentInvoiceIndex} />

              {/* Purchase */}
              <Route path="/PurchaseIndex" component={PurchaseIndex} />

              {/* Sale */}
              <Route path="/SaleIndex" component={SaleIndex} />

              {/* Payment Receipts */}
              <Route path="/PaymentReceiptsIndex" component={PaymentReceiptsIndex} />

              {/* Journal Entry */}
              <Route path="/JournalEntryIndex" component={JournalEntryIndex} />

              {/* Stock Report */}
              <Route path="/StockReportIndex" component={StockReportIndex} />

              {/* Company */}
              <Route path="/CompanyEdit" component={CompanyEdit} />

              {/* Reports */}
              <Route path="/MonthlyEstimateReport" component={MonthlyEstimateReport} />
              <Route path="/ItemForecastReport" component={ItemForecastReport} />
              <Route path="/DeliverySummaryReport" component={DeliverySummaryReport} />
              <Route path="/LedgerReport" component={LedgerReport} />
              <Route path="/CashBook" component={CashBook} />
              <Route path="/DeliveryStockReport" component={DeliveryStockReport} />
              <Route path="/CustomerDueListReport" component={CustomerDueListReport} />
              <Route path="/VendorDueListReport" component={VendorDueListReport} />
              <Route path="/PurchasePartyandItemWiseReport" component={PurchasePartyandItemWiseReport} />
              <Route path="/SalePartyandItemWiseReport" component={SalePartyandItemWiseReport} />
              <Route path="/RentInvoicePartyandItemWiseReport" component={RentInvoicePartyandItemWiseReport} />
            </Switch>
          </Box>
        </Box>

        {/* Mobile Bottom Navigation */}
        {isMobile && username !== "Counter" && <MobileBottomNav />}
      </Router>
    </ThemeProvider>
  );
};

// ---------------- Root ---------------- //
const App = () => {
  // Service worker and PWA functionality removed

  return (
    <Router>
      <AuthProvider>
        <Layout />
      </AuthProvider>
    </Router>
  );
};
export default App;
